import { render, staticRenderFns } from "./memberSetting.vue?vue&type=template&id=bc8c8364&"
import script from "./memberSetting.vue?vue&type=script&lang=js&"
export * from "./memberSetting.vue?vue&type=script&lang=js&"
import style0 from "./memberSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports